import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
    onClick?: () => void;
}

export const PlayBookIcon = observer(
    'PlayBookIcon',
    ({ className, onClick }: PropsType): JSX.Element => (
        <SvgElement
            className={className}
            onClick={onClick}
            fill='none'
            width='28'
            height='25'
            viewBox='0 0 28 25'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#playbookLogoIdA)'>
                <path
                    fill='#FFD600'
                    fillRule='evenodd'
                    d='M.5 10.043c-.258-.548.183-1.169.779-1.096l25.296 3.067a.77.77 0 0 1 .648.951l-.209.845a.769.769 0 0 1-.393.5L7.926 23.946a.758.758 0 0 1-1.034-.354L.5 10.043Z'
                    clipRule='evenodd'
                />
                <path
                    fill='#ED1E79'
                    fillRule='evenodd'
                    d='M8.087 24.155a.76.76 0 0 1-1.085-.505L3.127 7.558a.766.766 0 0 1 .911-.932l22.79 5.306a.77.77 0 0 1 .569.938l-.304 1.228a.769.769 0 0 1-.395.5L8.087 24.155Z'
                    clipRule='evenodd'
                />
                <path
                    fill='#9601F0'
                    fillRule='evenodd'
                    d='M8.337 24.313a.762.762 0 0 1-1.108-.686V5.04c0-.542.54-.915 1.04-.717l18.713 7.425a.772.772 0 0 1 .46.904l-.428 1.736a.769.769 0 0 1-.393.499L8.337 24.313Z'
                    clipRule='evenodd'
                />
                <path
                    fill='#15CE92'
                    fillRule='evenodd'
                    d='M7.987 24.447a.768.768 0 0 1-.739-.957L12.61 1.81a.76.76 0 0 1 1.162-.454l13.721 9.25c.268.18.395.511.317.827l-3.073 12.43a.763.763 0 0 1-.74.584H7.988Z'
                    clipRule='evenodd'
                />
                <path
                    fill='#fff'
                    d='M13.24 19.871a1.556 1.556 0 0 1-.33-1.679c.116-.28.31-.521.562-.69a1.512 1.512 0 0 1 1.693 0c.25.169.446.41.56.69a1.554 1.554 0 0 1-.33 1.68 1.517 1.517 0 0 1-2.154 0Zm1.617-1.634a.76.76 0 0 0-1.302.546.777.777 0 0 0 .471.712.757.757 0 0 0 .832-.168.777.777 0 0 0 0-1.09ZM16.364 11.047l-.718-.726-.718.726-.719-.726-.718.726.719.727-.719.726.719.726.718-.726.718.726.718-.726-.718-.726.718-.727ZM22.524 17.274l-.718-.726-.719.726-.718-.726-.718.726.718.726-.718.727.718.726.718-.726.719.726.718-.726-.718-.727.718-.726Z'
                />
                <path
                    fill='#fff'
                    fillRule='evenodd'
                    d='m20.803 13.559 1.018-.03.075-2.572-2.545.075-.03 1.03.807-.025-4.508 4.558.699.706 4.508-4.558-.024.816Zm.045-1.537v-.006h-.006l.006.006Z'
                    clipRule='evenodd'
                />
            </g>
            <defs>
                <clipPath id='playbookLogoIdA'>
                    <path
                        fill='#fff'
                        d='M0 .75h28v23.78H0z'
                    />
                </clipPath>
            </defs>
        </SvgElement>
    )
);
